<h2 *ngIf="is_create">Añadir nuevo elemento</h2>
<h2 *ngIf="!is_create">Modificar elemento</h2>
<div class="p-grid">
    <div class="p-col-6 p-field">
        <label for="code">Código</label>
        <input name="code" type="text" pInputText [(ngModel)]="element.code" [disabled]="!is_create"/>
    </div>
    <div class="p-col-6 p-field">
        <label for="text">Valor</label>
        <input name="text" type="text" pInputText [(ngModel)]="element.text"/>
    </div>
    <div class="p-col-12 p-d-flex">
        <p-button label="Borrar" *ngIf="false" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary p-button-text" (click)="cancel()">
        </p-button>
        <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
        <p-button label="Guardar y continuar" icon="pi pi-check" styleClass="p-ml-2" (click)="save(true)"></p-button>
    </div>
</div>
